<template>
  <d-container
    :paddingless-mobile="true"
    fluid
  >
    <div class="max-w-3xl">
      <d-card>
        <v-form
          :data="form"
          :url="endpoint.url"
          :method="endpoint.method"
          format="formData"
          :form-data-options="{
            nullsAsUndefineds: false,
            booleansAsIntegers: true,
            allowEmptyArrays: true,
            indices: true,
          }"
          @success="$router.push('/users')"
        >
          <d-card-row>
            <v-input
              v-model="form.name"
              name="name"
              required
            />
            <v-input
              v-model="form.email"
              name="email"
              required
            />
          </d-card-row>
          <d-card-row
            v-if="
              action == 'create' ||
                user.role == 'admin' ||
                user.role == 'employee'
            "
          >
            <v-input-select
              v-model="form.role"
              name="role"
              required
            >
              <option value="">
                {{ $t("select").capitalize() }}
              </option>
              <option
                v-for="(role, key) in formatRoles()"
                :key="key"
                :value="role"
              >
                {{ $t(role).capitalize() }}
              </option>
            </v-input-select>
          </d-card-row>

          <d-card-row v-if="form.role == 'employee'">
            <div class="mb-4">
              <label class="label mb-2">
                {{ $t("profile_picture").capitalize() }}
              </label>
              <figure
                v-if="profilePicture"
                class="image is-128x128 mb-4"
              >
                <img
                  class="is-rounded"
                  :src="profilePicture"
                >
              </figure>

              <b-field>
                <b-upload
                  v-model="form.avatar"
                  :multiple="false"
                  drag-drop
                  type="is-primary"
                  accept="image/*"
                  @input="onProfilePictureUpload"
                >
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>
                        <b-icon
                          icon="upload"
                          size="is-large"
                        />
                      </p>
                      <p>{{ $t("drop_or_click_to_upload") }}</p>
                    </div>
                  </section>
                </b-upload>
              </b-field>
            </div>
            <div class="mb-4">
              <v-input
                v-model="form.experience"
                type="number"
                name="experience"
              />
            </div>
            <div class="mb-4">
              <v-input-rich-text
                v-model="form.bio"
                name="bio"
              />
            </div>
          </d-card-row>
          <d-card-row>
            <v-input-select
              v-model="form.locale"
              name="locale"
              required
            >
              <option
                v-for="(locale, code) in $laravel.app.locales"
                :key="code"
                :value="code"
              >
                {{ locale }}
              </option>
            </v-input-select>
          </d-card-row>

          <d-card-row
            v-if="
              action == 'create' || (user && user.can['overwrite-password'])
            "
          >
            <v-input
              v-model="form.password"
              required
              name="password"
              :label="passwordLabel"
              type="password"
              :password-reveal="true"
            />
          </d-card-row>
          <d-card-row>
            <button
              class="button is-primary"
              type="submit"
            >
              {{ $t("save") }}
            </button>
          </d-card-row>
        </v-form>
      </d-card>
    </div>
  </d-container>
</template>

<script>

import { fillFields } from "@/services/helpers";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
    user: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      profilePicture: null,
      form: {
        name: "",
        email: "",
        locale: this.$laravel.app.locale,
        avatar:null,
        password: "",
        role: "",
        experience:"",
        bio: "",
      },
    };
  },
  computed: {
    endpoint() {
      if (this.action === "create") {
        return {
          method: "post",
          url: route("api.users.store"),
        };
      }
      if (this.action === "edit") {
        return {
          method: "patch",
          url: this.$laravel.route("api.users.update", { user: this.user.id }),
        };
      }
      return null;
    },
    passwordLabel() {
      return this.action === "create"
        ? this.$t("attributes.password").capitalize()
        : this.$t("attributes.password").capitalize() +
            " (" +
            this.$t("leave_empty_to_keep_current").capitalize() +
            ")";
    },
  },
  created() {
    if (this.action === "edit") {
      // this.form = _.cloneDeep(this.user);
      this.form = fillFields(this.form, this.user);

      this.profilePicture = null;
      this.form.avatar = null;

      if (typeof this.user.avatar === "object" && this.user.avatar !== null) {
        this.profilePicture = this.user.avatar.url ?? null;
      }
      if (typeof this.user.avatar === "string") {
        this.profilePicture = this.user.avatar;
      }
    }
  },
  methods: {
    formatRoles() {
      return this.$laravel.roles.filter(
        (role) => role !== this.$laravel.role_client
      );
    },
    onProfilePictureUpload(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.profilePicture = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style scoped>
.is-128x128 img {
  width: 128px;
  height: 128px;
  object-fit: cover;
}
</style>
